exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "#password-recovery #recovery-wrapper[data-v-f8b9093c]{display:block;margin-left:auto;margin-right:auto;width:fit-content;width:-moz-max-content}#password-recovery .reset-container[data-v-f8b9093c]{display:flex;flex-flow:column}#password-recovery .reset-container .reset-info[data-v-f8b9093c]{font-weight:300;font-size:18px}#password-recovery .reset-container .reset-data[data-v-f8b9093c]{display:flex;align-items:center}#password-recovery .reset-container .reset-data .input-default[data-v-f8b9093c]{min-width:300px;margin-bottom:0}#password-recovery .reset-container .reset-data .btn-send[data-v-f8b9093c]{margin-left:1em}#password-recovery .reset-container .errors[data-v-f8b9093c]{margin-top:.5em;margin-left:1em}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-rewriter.js?id=data-v-f8b9093c&scoped=true!./~/sass-loader!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/PasswordRecovery.vue
// module id = 158
// module chunks = 0